import { axios } from 'common/utils'
import { StoreCategoryParams } from 'common/types/params'
import { StoreCategory } from 'common/types/entities/mongo/storeCategory'

export const fetchStoreCategories = async (params: StoreCategoryParams): Promise<StoreCategory[]> => {
  const result = await axios.get<StoreCategory[]>(`/v1/store-categories`, {
    params,
  })
  return result && result.data
}
